import { FC, useMemo } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';

import SkyflagBannerImg from '@/assets/images/banner/skyflag.png';
import SkyflagBannerImgWebp from '@/assets/images/banner/skyflag.png?webp';
import { useUserContext } from '@/contexts/user';

import Banner, { BannerData } from '..';

const SkyflagBanner: FC<Pick<BannerData, 'width' | 'height' | 'overflow'>> = ({
  width,
  height,
  overflow,
}) => {
  const { user } = useUserContext();

  const skyflagLink = useMemo(() => {
    let owp: string = import.meta.env.VITE_SKYFLAG_PC_OWP;

    if (isIOS) {
      owp = import.meta.env.VITE_SKYFLAG_IOS_OWP;
    }
    if (isAndroid) {
      owp = import.meta.env.VITE_SKYFLAG_ANDROID_OWP;
    }

    return `${import.meta.env.VITE_SKYFLAG_BASE_URL}?_owp=${owp}&suid=${
      user.userId
    }`;
  }, []);

  return (
    <Banner
      srcSet={SkyflagBannerImg}
      mediaSet={[
        {
          srcSet: SkyflagBannerImgWebp,
          type: 'image/webp',
        },
      ]}
      alt="条件クリアでtoreta+をGET!!"
      width={width}
      height={height}
      link={skyflagLink}
      external
      overflow={overflow}
    />
  );
};

export default SkyflagBanner;
